import {textSizes} from '@stencil/build-theme/src/build-theme';
import styled from 'styled-components';

export const Cancel_policy_wrap = styled.div(props => ({
  display: 'flex',
  'flex-direction': 'column',
  ...props.styles,
}));

export const FreeCancelText = styled.p(
  props => `
  width:40%;
  font-size: ${props.theme.font.custom(14)};
  color: ${props.theme.colors.downriver.medium};
  margin-top: ${props.theme.spacing.large};
  `,
);

export const Header_p = styled.p(
  props => `
  ${textSizes.BaseW3};
  margin-bottom:${props.titleStyles.marginBottom || props.theme.spacing.small};
  ${props.titleStyles.fontFamily && `font-family: ${props.titleStyles.fontFamily};`}
   ${props.titleStyles.borderBottom && `border-bottom: ${props.titleStyles.borderBottom};`}
    ${props.titleStyles.paddingBottom && `padding-bottom: ${props.titleStyles.paddingBottom};`}
  `,
);

export const Sub_Header_p = styled.p(
  props => `
  font-size: ${props.theme.font.custom(14)};
  color: ${props.theme.colors.downriver.medium};
  `,
);

export const FlexWrap = styled.div(
  props => `
        display:flex;
        `,
);

export const CancellationList = styled.ul(
  props => `
  margin-top:15px;
   > li {
     display:flex;
     align-items:center;
   }
  `,
);

export const GreyDot = styled.span(
  props => `
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #4a4a4a;
  display: inline-block;
  flex-shrink: 0;
  margin-top: 3px;
  margin-right:5px
  `,
);

export const DescriptionText = styled.span`
  ${textSizes.SmallW2};
`;

export const RuleWithDescription = styled.div(
  props => `
  margin-top:25px;
  `,
);

export const RuleWithText = styled.p`
  ${textSizes.SmallW3}
  margin-bottom:15px;
`;
export const CancellationPolicyTable = styled.div(
  props => `
    border-radius: 4px;
    border: solid 1px #d0d5df;
    background-color: #ffffff;
    overflow: hidden;
    margin-bottom: 15px;

    .cncpolicyTbl__col {
      width: 50%;
      padding: 6px 10px;
    }

    .cncpolicyTbl__head {
      border-bottom: solid 1px #d0d5df;
      display: flex;
      font-size: 11px;
      font-weight: 900;
    }
    .cncpolicyTbl__head .cncpolicyTbl__col {
      ${textSizes.SmallW3};
      background-color: #f1f3f7;
    }
    .cncpolicyTbl__head .cncpolicyTbl__col:first-child {
      border-right: solid 1px #d0d5df;
    }
    .cncpolicyTbl__row {
      display: flex;
    }
    .cncpolicyTbl__row .cncpolicyTbl__col {
      padding: 12px 10px;
      ${textSizes.SmallW1};
    }
    .cncpolicyTbl__row .cncpolicyTbl__col:first-child {
      border-right: solid 1px #d0d5df;
    }
    .cncpolicyTbl__row {
      border-bottom: solid 1px #d0d5df;
    }
    .cncpolicyTbl__row:last-child {
      border-bottom: 0;
    }
  `,
);

export const BaseColumnWrap = styled.div(props => ({
  display: 'flex',
  'flex-direction': 'column',
  width: '100%',
  ...props.styles,
}));
